import React from 'react';
import { Accomplishments } from '../types';
import Icon from '../utils/icons';

export const accomplishments: Accomplishments = {
    certifications: [
        {
            title: "Introduction to Back-End Development",
            issuer: "Meta",
            date: "Nov 2024",
            color: "#0866FF",
            emoji: <Icon name="book" />,
            link: "https://www.coursera.org/account/accomplishments/verify/"
        },
        {
            title: "Version Control (Git & GitHub)",
            issuer: "Meta",
            date: "Oct 2024",
            color: "#0866FF",
            emoji: <Icon name="book" />,
            link: "https://www.coursera.org/account/accomplishments/verify/"
        },
        {
            title: "Programming in Python",
            issuer: "Coursera",
            date: "2023",
            color: "#0056d2",
            emoji: <Icon name="python" />,
            link: "https://www.coursera.org/"
        },
        {
            title: "Python Skill Certificate",
            issuer: "HackerRank",
            date: "2023",
            color: "#00ea64",
            emoji: <Icon name="laptop" />,
            link: "https://www.hackerrank.com/certificates/"
        },
        {
            title: "Certificate of Appreciation — MoralityCode AI",
            issuer: "United Nations Volunteers (UNV)",
            date: "Dec 2025",
            color: "#009EDB",
            emoji: <Icon name="un" />,
            link: "https://www.unv.org/"
        },
        {
            title: "Certificate of Appreciation — UN 80th Anniversary",
            issuer: "United Nations",
            date: "Nov 2025",
            color: "#009EDB",
            emoji: <Icon name="un" />,
            link: "https://www.unv.org/"
        },
        {
            title: "Acquaint Volunteer Certificate",
            issuer: "Acquaint",
            date: "2025",
            color: "#43e55e",
            emoji: <Icon name="handshake" />,
            link: "https://www.acquaint.org/shared_certificates/6eda4711-29d1-4b08-afcf-ae1ec0367494"
        },
        {
            title: "Academic Excellence — First Rank, Year 4",
            issuer: "Al-Baath University",
            date: "Jul 2019",
            color: "#7c3aed",
            emoji: <Icon name="trophy" />,
            link: ""
        },
        {
            title: "Recognition Letter",
            issuer: "General Electricity Company, Syria",
            date: "Oct 2020",
            color: "#d97706",
            emoji: <Icon name="flash" />,
            link: ""
        }
    ]
};
